import "./styles/index.css";
import { applyTheme } from "./config/theme.js";
import { App } from "./app/App.js";

try {
  applyTheme();
} catch (error) {
  console.error("Theme could not apply", error);
}

const root = document.getElementById("app");
try {
  new App(root);
} catch (error) {
  console.error("App failed to start", error);
}
